import { FETCH_WIDGETS_SUCCESS } from '../../types'

export default function successAction(res) {
  const data = res.json.data.widgets.data
  return { type: FETCH_WIDGETS_SUCCESS, payload: { widgets: data } }
}
